import f from './functions'

var ids = {
    web : '1075755841648-vrk4fio6jm103qqme0avb1crr0p0vulc.apps.googleusercontent.com',
    ios : '1075755841648-aqvo4nm7oeecbo2frh8dlti3u6guc4ek.apps.googleusercontent.com',
    android : '1075755841648-6derr1mq4mrb8cugjtn79bs88nkmooa0.apps.googleusercontent.com'
}

var Cwgapi = function(){
    var self = this
    var clientid = null

    var data = null

    self.auth2 = {
        init : function(p){

            clientid = ids.web// p.client_id

            return Promise.resolve()

        },

        getAuthInstance : function(){
            return self
        },

        
    }

    self.currentUser = {
        get : function(){

            if(!data) return null


            var _data = {

                rt : {
                    FV : data.givenName,
                    GT : data.familyName,
                    iK : data.imageUrl,

                },

                wc : {
                    access_token : data.accessToken,
                    idToken : ''
                }

            }

            return _data
        }
    }

    self.clearWh = function(){
        data = null;
    }

    self.signIn = function(){
        return new Promise((resolve, reject) => {

            window.plugins.googleplus.login(
                {
                    webClientId: clientid,
                },

                function (obj){

                    data = obj

                    resolve(obj)
                  
                },

                function (msg, e, d) {
                    console.log(msg, e, d)
                    reject(msg)
                }
            );

        })
    }

    self.load = function(fakeid, clbk){
        if(clbk) clbk()
    }

    return self
}

var Authways = function({
    user
}){
    var self = this;

    var wgapi = null;

    

    var google = {
        auth : null
    }

    var getpl = function(){
        if(window.cordova && window.device && f.deep(window, 'device.platform') == 'iOS') return 'ios'
        if(window.cordova) return 'android'
        
        return 'web'

    }

    self.init = function(){


        return new Promise((resolve, reject) => {

            f.retry(function () {
                if(typeof gapi != 'undefined') wgapi = gapi;
    
                if(window.cordova) wgapi = new Cwgapi();

                return wgapi;

            }, function () {

                if(typeof wgapi != 'undefined'){

                

                    wgapi.load('auth2', function() {
    
                        wgapi.auth2.init({
    
                            client_id: ids[getpl()]
    
                        }).then(r => {
    
                            google.auth = wgapi.auth2.getAuthInstance()
    
                            console.log(wgapi, google.auth)
    
                            resolve(google.auth)     
    
                        }).catch(e => {
    
                            console.error(e)
    
                            resolve(null)
                        })
            
                    })
    
                }
    
                else{
                    resolve(null)
                }
    
            }, 5)


            

        })
       
    }

    self.data = {
        apple : function(data){

            var _data = {
                email : data.email,
                firstname : data.fullName.givenName,
                lastname : data.fullName.familyName,
                image : '',

                accessToken : data.authorizationCode,
                idToken :  data.identityToken,
                type : 'apple'
            }

            return Promise.resolve(_data)

        },
        google : function(){
            var gdata = google.auth.currentUser.get()

            if(!gdata || !gdata.rt || !gdata.wc) return Promise.reject('emptyData')

            console.log('gdata', gdata)

            var data = {
                //email : gdata.rt.$t,
                firstname : gdata.rt.FV,
                lastname : gdata.rt.GT,
                image : gdata.rt.iK,

                accessToken : gdata.wc.access_token,
                idToken :  gdata.wc.id_token,
                type : 'google'
            }

            return Promise.resolve(data)
        }
    }


    self.link = function(payload){
        return user.link(payload)
    }

    self.signin = {
        apple : function(){

            return new Promise((resolve, reject) => {

                var profile = {}

                window.cordova.plugins.SignInWithApple.signin(

                    { requestedScopes: [0, 1] },

                    function(data){

                        console.log("APPLEDATA", data)

                        self.data.apple(data).then(_data => {
                            profile.data = _data

                            return Promise.resolve()
                        }).then(() => {

                            return self.link(profile.data)
            
                        }).then((d) => {

                            return resolve(d)

                        }).catch(e => {
            
                            return reject(e)
            
                        })

                    },

                    function(err){
                        console.error(err)
                        
                        reject(err)
                    }
                )

            })
        },
        google : function(){

            if (wgapi.clearWh) 
                wgapi.clearWh()

            var profile = {}

            if(!google.auth){
                return Promise.reject("Sign in with google isn't available")
            }

            return google.auth.signIn({
                scope: 'profile email'
            }).then(r => {

                profile.auth = r

                return self.data.google()

            }).then(r => {

                profile.data = r

                return Promise.resolve()

            }).then(() => {
                console.log("DATAs", profile.data)
                return self.link(profile.data)

                return Promise.resolve()

            }).catch(e => {
                console.error(e)

                return Promise.reject(e)

            })
        }
    }

    return self;
}

export default Authways